import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestReportStockAbcCurve } from './StockAbcCurve.service';
import reportNotificationError from '@/utils/functions/notificationErrorNetReport';

export function useStockAbcCurveReport() {
  return useMutation(getQuestReportStockAbcCurve, {
    onSuccess() {
      notification.success({
        message: 'O relatório Curva ABC foi gerado com sucesso!',
      });
    },

    onError(error) {
      reportNotificationError(error);
    },
  });
}
